import { GET_WEAPON_TYPES_LOADING, GET_WEAPON_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getWeaponTypesSuccess = payload => {
    return ({
        type: GET_WEAPON_TYPES_SUCCESS,
        payload
    })
}

export const getWeaponTypesAsync = payload => dispatch => {
    return client.service('weapon-types').find()
		.then((response) => {
            dispatch(getWeaponTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}